import React from "react";
import LoginForm from "./LoginForm";
import { Grid, Box } from "@material-ui/core";
import asu_logo from "../../../assets/asu_logo.png";
import useStyles from "./Styles";

function LoginPage() {
  const classes = useStyles();
  return (
    <Grid container item className={classes.landingPageContainer}>
      <Grid item xs={12}>
        <Box m={1} mb={1} className={classes.asuLogo}>
          <img
            src={asu_logo}
            className={classes.applogo}
            alt="asu"
            width="auto"
          />
        </Box>
      </Grid>
      <Grid item xs={12} className={classes.loginFormGrid}>
        <LoginForm />
      </Grid>
      {/* <Grid item xs={12} className={classes.landingPageGradient}></Grid> */}
    </Grid>
  );
}

export default LoginPage;
